import React, { useState } from 'react';
import { supabase } from '../../../services/supabaseClient';

const EditFinancialsModal = ({ submissionId, financialData, onClose, onSave }) => {
    const [formData, setFormData] = useState(financialData || {});
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        setSaving(true);
        try {
            const { error } = await supabase
                .from('wizard_submissions')
                .update({ financial_info: formData })
                .eq('id', submissionId);

            if (error) throw error;
            if (onSave) await onSave();
            onClose();
        } catch (err) {
            console.error('Error saving financials:', err);
            alert('Failed to save financial information');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="bg-gray-900/50 p-4 border-b border-gray-700 flex items-center justify-between sticky top-0">
                    <h3 className="text-lg font-bold text-white uppercase tracking-wider">Edit Financial Information</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-white"
                    >
                        ✕
                    </button>
                </div>

                <div className="p-6 space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Annual Income</label>
                            <input
                                type="text"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.annualIncome || ''}
                                onChange={(e) => setFormData({ ...formData, annualIncome: e.target.value })}
                                placeholder="e.g., $50,000"
                            />
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Savings Amount</label>
                            <input
                                type="text"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.savingsAmount || ''}
                                onChange={(e) => setFormData({ ...formData, savingsAmount: e.target.value })}
                                placeholder="e.g., $20,000"
                            />
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Currency</label>
                            <select
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.currency || 'USD'}
                                onChange={(e) => setFormData({ ...formData, currency: e.target.value })}
                            >
                                <option value="USD">USD - US Dollar</option>
                                <option value="EUR">EUR - Euro</option>
                                <option value="GBP">GBP - British Pound</option>
                                <option value="CAD">CAD - Canadian Dollar</option>
                                <option value="AUD">AUD - Australian Dollar</option>
                                <option value="LKR">LKR - Sri Lankan Rupee</option>
                                <option value="INR">INR - Indian Rupee</option>
                            </select>
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Funding Source</label>
                            <select
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.fundingSource || ''}
                                onChange={(e) => setFormData({ ...formData, fundingSource: e.target.value })}
                            >
                                <option value="">Select funding source</option>
                                <option value="Personal Savings">Personal Savings</option>
                                <option value="Family Sponsorship">Family Sponsorship</option>
                                <option value="Bank Loan">Bank Loan</option>
                                <option value="Scholarship">Scholarship</option>
                                <option value="Employer Sponsorship">Employer Sponsorship</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                    </div>

                    <div className="flex items-center pt-2">
                        <label className="flex items-center gap-2 text-sm text-gray-300">
                            <input
                                type="checkbox"
                                checked={formData.sponsorAvailable || false}
                                onChange={(e) => setFormData({ ...formData, sponsorAvailable: e.target.checked })}
                                className="rounded border-gray-600 bg-gray-900"
                            />
                            Sponsor Available
                        </label>
                    </div>

                    <div className="flex gap-3 justify-end mt-6 pt-4 border-t border-gray-700">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 rounded text-sm font-bold bg-gray-700 text-white hover:bg-gray-600 border border-gray-600"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleSave}
                            disabled={saving}
                            className="px-4 py-2 rounded text-sm font-bold bg-blue-600 text-white hover:bg-blue-700 border border-blue-500 disabled:opacity-50"
                        >
                            {saving ? 'Saving...' : 'Save Changes'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditFinancialsModal;
